import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { fetcher_default } from "./chunk-GONJSORR.mjs";
import { __export } from "./chunk-QK4PKNB3.mjs"; // src/services/diary.ts

var diary_exports = {};

__export(diary_exports, {
  createComment: function createComment() {
    return _createComment;
  },
  getDiaries: function getDiaries() {
    return _getDiaries;
  },
  getDiary: function getDiary() {
    return _getDiary;
  },
  getDiaryDates: function getDiaryDates() {
    return _getDiaryDates;
  }
});

import moment from "moment";

var _getDiary = function _getDiary(clientId, date, dates) {
  return fetcher_default.get("/v4/diaries/search", {
    client_id: clientId,
    date: date,
    dates: dates
  });
};

var _getDiaries = function _getDiaries(clients) {
  return fetcher_default.get("/v4/diaries/search_by_clients", {
    clients: clients
  });
};

var _getDiaryDates = function _getDiaryDates(clientId, after, before) {
  var payload = !before && !after ? {
    after: moment().subtract(4, "month").format("YYYY-MM-DD")
  } : {
    after: after,
    before: before
  };
  return fetcher_default.get("/v4/diaries/dates", _objectSpread(_objectSpread({}, payload), {}, {
    client_id: clientId
  }));
};

var _createComment = function _createComment(_ref) {
  var _ref$record = _ref.record,
      _type = _ref$record._type,
      id = _ref$record.id,
      content = _ref.content;
  var path = "";
  var payload = {};

  switch (_type) {
    case "noteAsset":
      path = "assets/".concat(id);
      payload = {
        content: content
      };
      break;

    case "note":
      path = "notes/".concat(id);
      payload = {
        content: content
      };
      break;

    case "foodRecordPhoto":
      path = "food_record_assets";
      payload = {
        content: content,
        id: id,
        type: "photo"
      };
      break;

    case "foodRecordNote":
      path = "food_record_assets";
      payload = {
        content: content,
        id: id,
        type: "note"
      };
      break;

    default:
      break;
  }

  return fetcher_default.post("/v4/".concat(path, "/create_comment"), payload);
};

export { _getDiary as getDiary, _getDiaries as getDiaries, _getDiaryDates as getDiaryDates, _createComment as createComment, diary_exports };